// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/desktop/clients.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/desktop/schedule.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../assets/desktop/tasks.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../assets/desktop/blog.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../../assets/desktop/settings.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.desktop_left{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 14px;
    height: 100%;
}

.desktop_top{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 14px;
}

.desktop_bottom{
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    gap: 14px;
}

.desktop_menu_item{
    display: flex;
    justify-content: flex-start;
    align-items: center;

    width: 238px;
    height: 54px;
    background: #FFFFFF;
    box-shadow: 0px 4px 31.4423px rgba(202, 196, 208, 0.56);
    border-radius: 24px;

    font-weight: 700;
    font-size: calc(16px * var(--fontScaler));
    line-height: 18px;

    color: #000000;

    gap: 24px;
    padding: 0px 39px;
    cursor: pointer;
}

.desktop_menu_item:hover{
    box-shadow: 0px 4px 31.4423px rgba(202, 196, 208, 0.56), 0px 4px 5px rgba(202, 196, 208, 1);
}

.desktop_menu_item::before{
    content: "";
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    width: 24px;
    height: 24px;
    flex-shrink: 0;
}

.desktop_menu_item--clients::before{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.desktop_menu_item--schedule::before{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.desktop_menu_item--tasks::before{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.desktop_menu_item--blog::before{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.desktop_menu_item--settings::before{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/desktop/DesktopRightMenu.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;;IAEnB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,uDAAuD;IACvD,mBAAmB;;IAEnB,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;;IAEjB,cAAc;;IAEd,SAAS;IACT,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,2FAA2F;AAC/F;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,4BAA4B;IAC5B,wBAAwB;IACxB,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,yDAA+D;AACnE;;AAEA;IACI,yDAAgE;AACpE;;AAEA;IACI,yDAA6D;AACjE;;AAEA;IACI,yDAA4D;AAChE;;AAEA;IACI,yDAAgE;AACpE","sourcesContent":[".desktop_left{\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    gap: 14px;\n    height: 100%;\n}\n\n.desktop_top{\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    gap: 14px;\n}\n\n.desktop_bottom{\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    gap: 14px;\n}\n\n.desktop_menu_item{\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n\n    width: 238px;\n    height: 54px;\n    background: #FFFFFF;\n    box-shadow: 0px 4px 31.4423px rgba(202, 196, 208, 0.56);\n    border-radius: 24px;\n\n    font-weight: 700;\n    font-size: calc(16px * var(--fontScaler));\n    line-height: 18px;\n\n    color: #000000;\n\n    gap: 24px;\n    padding: 0px 39px;\n    cursor: pointer;\n}\n\n.desktop_menu_item:hover{\n    box-shadow: 0px 4px 31.4423px rgba(202, 196, 208, 0.56), 0px 4px 5px rgba(202, 196, 208, 1);\n}\n\n.desktop_menu_item::before{\n    content: \"\";\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: contain;\n    width: 24px;\n    height: 24px;\n    flex-shrink: 0;\n}\n\n.desktop_menu_item--clients::before{\n    background-image: url(\"../../../../assets/desktop/clients.png\");\n}\n\n.desktop_menu_item--schedule::before{\n    background-image: url(\"../../../../assets/desktop/schedule.png\");\n}\n\n.desktop_menu_item--tasks::before{\n    background-image: url(\"../../../../assets/desktop/tasks.png\");\n}\n\n.desktop_menu_item--blog::before{\n    background-image: url(\"../../../../assets/desktop/blog.png\");\n}\n\n.desktop_menu_item--settings::before{\n    background-image: url(\"../../../../assets/desktop/settings.png\");\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
